
export const PopupTypes = {
    ShortReservation: 1001
}

export const icons = [
    {
        "color": "#38bbf7",
        "items": [
            {
                "title": "ReservationSearch",
                "icon": "icon-search-in-folder",
                "url": "PMS/Reservations/Search",
                "mobile": true
            },
            {
                "title": "NewReservation",
                "icon": "icon-file",
                "url": "PMS/Reservations/Index",
                "mobile": true
            },
            {
                "title": "ShortReservation",
                "icon": "icon-edit",
                "url": "#shortReservation",
                "externalSystemID": PopupTypes.ShortReservation,
                "mobile": true
            },
            {
                "title": "GroupReservation",
                "icon": "icon-multiple-users-silhouette",
                "url": "PMS/ReservationGroupDataService/ReservationGroup"
            }
        ]
    },
    {
        "color": "#cf1b58",
        "items": [
            {
                "title": "Customers",
                "icon": "icon-users-1",
                "url": "CRM/Customers/Customers"
            },
            {
                "title": "CRM",
                "icon": "icon-masculine-avatar-user-with-suit",
                "url": "CRM/Guest/SearchGuests",
                "mobile": true
            }
        ]
    },
    {
        "color": "#FF9800",
        "items": [
            {
                "title": "GuestInHouse",
                "icon": "icon-keychain-with-key",
                "url": "PMS/Reservations/GuestsInHouse"
            }, {
                "title": "Arrivals",
                "icon": "icon-hotel-reception-bell",
                "url": "PMS/Reservations/Arrivals"
            }, {
                "title": "Housekeeping",
                "icon": "icon-wiping-swipe-for-floors",
                "url": "PMS/HotelHousekeeping/Index",
                "mobile": true
            }, {
                "title": "Calendar",
                "icon": "icon-analysis-chart",
                "url": "PMS/TapeChart/Calendar",
                "mobile": true
            }
        ]
    }, {
        "color": "#01A7BD",
        "items": [
            {
                "title": "MonthlyView",
                "icon": "icon-calendar",
                "url": "PMS/Monthly"
            },
            {
                "title": "Restriction",
                "icon": "icon-do-not-disturbe",
                "url": "PMS/Restriction/Index/"
            }, {
                "title": "PriceList",
                "icon": "icon-dollar-symbol-2",
                "url": "PMS/PriceList"
            }, {
                "title": "OptimaLive",
                "icon": "icon-sun",
                "url": "PMS/Live/NewLive",
                "mobile": true
            }
        ]
    }, {
        "color": "#8BC34A",
        "items": [
            {
                "title": "FoliosSearch",
                "icon": "icon-money-finder",
                "url": "Finance/Folio/FolioSearch"
            }, {
                "title": "CurrencyExchange",
                "icon": "icon-currency-exchange",
                "url": "Finance/currency/CurrencyExchange"
            }, {
                "title": "OptimaShop",
                "icon": "icon-shopping-cart2",
                "url": "Finance/Folio/Folio?DailyFolio=true"
            }
        ]
    }, {
        "color": "#8b239d",
        "items": [
            {
                "title": "ChannelManager",
                "icon": "icon-business-affiliate-network",
                "url": "",
                "externalSystemID": 1,
                "connector": () => {
                    console.log('ChannelManager connector clicked');
                    console.log('window.optima exists:', typeof window.optima !== 'undefined');
                    console.log('window.optima.utils exists:', typeof window.optima?.utils !== 'undefined');
                    console.log('window.optima.utils.ConnectToChannelManager exists:', typeof window.optima?.utils?.ConnectToChannelManager);
                    
                    if (window.optima && window.optima.utils && window.optima.utils.ConnectToChannelManager) {
                        window.optima.utils.ConnectToChannelManager();
                    } else {
                        console.error('ConnectToChannelManager function not found!');
                    }
                }
            }, {
                "title": "Dashboard",
                "icon": "grid layout",
                "url": "Home/Dashboard",
                "mobile": true
            }, {
                "title": "Reports",
                "icon": "icon-document-with-line-chart",
                "url": "SharedServices/Control/Report"
            }, {
                "title": "AnalyticsReports",
                "icon": "icon-pie-chart3",
                "url": "SharedServices/Control/Report/AnalyticsReport",
                "externalSystemID": 3
            }, {
                "title": "RevenueManagementSystem",
                "icon": "chart line",
                "url": "/Shell/ConnectionRMS",
                "hide": true
            }
        ]
    }
]